export default {
  getTimeSheetDocument: (state) => state.timeSheetDocument,
};
